import React, { useEffect, useState } from "react";
import Player from '../../components/StudentPortal/CoursePlayer/Player'
import Description from '../../components/StudentPortal/CoursePlayer/Description'
import VideoList from '../../components/StudentPortal/CoursePlayer/VideoList'
import { useParams } from "react-router-dom";
import { useGetVideoQuery } from "../../features/videos/videosApi";
import AssignmentModal from "../../components/StudentPortal/CoursePlayer/AssignmentModal";

const CoursePlayer = () => {
    const {videoId} = useParams();
    const [opened, setOpened] = useState(false);

  const controlModal = () => {
    setOpened((prevState) => !prevState);
  };

    const{ data: video, isLoading, isError, refetch} = useGetVideoQuery(videoId);

    if(isLoading){
        return <div> Loading...</div>
    }
    
  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="grid grid-cols-3 gap-2 lg:gap-8">
          <div className="col-span-full w-full space-y-8 lg:col-span-2">
            <AssignmentModal open={opened} control={controlModal} id={videoId}/>
            <Player video={video}/>
            <Description video={video} control={controlModal}/>
          </div>
          <VideoList />
        </div>
      </div>
    </section>
  );
};

export default CoursePlayer;
